import React, { type FC } from 'react'
import { Fragment } from 'react'

import { UtilService } from 'common/services/utilService'

interface IProps {
  total: number
  children: React.JSX.Element
}
export const ArrayElements: FC<IProps> = ({ total, children }) => (
  <>
    {UtilService.getFilledArray(total).map(
      (_, index: number): React.JSX.Element => (
        <Fragment key={index}>{children}</Fragment>
      ),
    )}
  </>
)
